import type { ComponentProps } from 'react';

import LaunchDarklyOsmoLogoMarkSvg from './launchdarkly-osmo-logomark.svg';
import LaunchDarklyOsmoLogoFullSvg from './launchdarkly-osmo.svg';

export type LaunchDarklyOsmoProps = ComponentProps<'svg'> & {
  mark?: boolean;
};

export const LaunchDarklyOsmo = ({ mark, ...props }: LaunchDarklyOsmoProps) =>
  mark ? <LaunchDarklyOsmoLogoMarkSvg {...props} /> : <LaunchDarklyOsmoLogoFullSvg {...props} />;
